import { Typography } from '@mui/material';
import { capitalizeFirstLetter } from '../../../shared';

const PredictionLabel = ({ category }) => {
    return (
        <Typography
            variant="h6"
            sx={{
                fontWeight: "bold",
                mb: 1.5,
                fontSize: "1.1rem",
                color: "primary.main",
                pl: 2,
            }}
        >
            {capitalizeFirstLetter(category)}
        </Typography>
    );
};

export default PredictionLabel;
